import { useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Text,
  useColorModeValue,
  Input,
  Tag,
  TagLabel,
  TagCloseButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  ModalFooter,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";

// Custom components
import Card from "components/card/Card";
import { FaFilter } from "react-icons/fa";

// Assets
import ClientsTable from "./components/ClientesInactiveTable";

type FilterProps = {
  [key: string]: string | number | any;
};

export default function MapContainer() {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const [filters, setFilters] = useState<FilterProps>({} as FilterProps);
  const { onOpen, onClose, isOpen } = useDisclosure();
  const { register, handleSubmit, setValue: formSetValue } = useForm();
  
  const handleRemoveFIlter = (filterKey: string) => {
    delete filters[filterKey];
    formSetValue(filterKey, "");

    setFilters({ ...filters });
  };

  const submitFilterUsers = (data: FilterProps) => {
		if(data.dias === undefined) data.dias = 6
    setFilters(data);
    onClose();
  };

  return (
    <Box pt={{ base: "180px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid templateColumns="1fr" gap={4} w="100%">
        <Flex direction="column">
          <Flex
            mt="45px"
            mb="20px"
            justifyContent="space-between"
            direction={{ base: "column", md: "row" }}
            align={{ base: "start", md: "center" }}
          >
            <Text color={textColor} fontSize="2xl" ms="24px" fontWeight="700">
              Clientes Inativos
            </Text>
            <Flex
              align="center"
              me="20px"
              ms={{ base: "24px", md: "0px" }}
              mt={{ base: "20px", md: "0px" }}
            >
              {Object.entries(filters).map(([key, value], index) => {
                if (value === "") {
                  return null;
                }
                return (
                  <Tag p={1.5} mr={2} key={index}>
                    <TagLabel>{String(value)}</TagLabel>
                    <TagCloseButton onClick={() => handleRemoveFIlter(key)} />
                  </Tag>
                );
              })}

              <Button onClick={onOpen}>
                <FaFilter />
              </Button>
            </Flex>
          </Flex>
          <Card px="0px" mb="20px">
            <ClientsTable dias={filters.dias ?? 6} nome={filters.nome} />
          </Card>
        </Flex>
      </Grid>

      {/* Modal do filtro */}

      <Modal isOpen={isOpen} onClose={onClose}>
        <form onSubmit={handleSubmit(submitFilterUsers)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Filtros de pesquisa</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel>Minimo de dias sem acesso</FormLabel>
                <Input
                  color={textColor}
                  {...register("dias")}
                  type="number"
                />
								<FormLabel>Nome</FormLabel>
                <Input
                  color={textColor}
                  {...register("nome")}
                  type="text"
                />
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="red" mr={3} onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit" colorScheme="teal">
                Aplicar
              </Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </Box>
  );
}
